import {Stack} from '@mui/material';
import {GridColDef, GridRenderEditCellParams, useGridApiContext} from '@mui/x-data-grid-pro';

import {Array} from '@utils/extensions/array.extension';
import {ColumnProps} from '@utils/table/columnTypes.table';

import SelectComponent, {SelectItem} from '@components/inputs/select/Select.component';

interface SelectColumnComponentProps extends GridRenderEditCellParams {
  options: SelectItem[];
  customRenderValue?: (row: any) => JSX.Element;
}

const SelectColumnComponent = (props: SelectColumnComponentProps) => {
  const {id, field, options, value, customRenderValue} = props;

  const apiRef = useGridApiContext();

  return (
    <Stack flex={1}>
      <SelectComponent
        items={options}
        customRenderValue={customRenderValue}
        handleChange={(newValue) => apiRef.current.setEditCellValue({id, field, value: newValue})}
        value={value}/>
    </Stack>
  );
};

interface SelectColumnProps extends ColumnProps {
  disabled?: (row: any) => boolean;
  hideInput?: (row: any) => boolean;
  customRenderValue?: (row: any) => JSX.Element;
  options?: SelectItem[];
}

export const COLUMN_TYPE_SELECT = (props: SelectColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  flex: props.fullWidth ? 1 : undefined,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  editable: props.editable,
  renderCell: (params) => {
    if (props.hideInput?.(params.row)) {
      return params.value;
    }
    return (
      <Stack flex={1}>
        <SelectComponent
          readOnly
          customRenderValue={props.customRenderValue}
          items={props.options ?? []}
          value={params.value}/>
      </Stack>
    );
  },
  renderEditCell: (params) => {
    if (props.hideInput?.(params.row)) {
      return params.value;
    }
    return (
      <SelectColumnComponent
        {...params}
        customRenderValue={props.customRenderValue}
        options={props.options ?? []}/>
    );
  },
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});
